import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const makitoHistory = {
  last: '/', // For other components using, capture this and save on first render because the new component navigation will override this once loaded.
  history: [] as any,
};
export const makitoLocation = '/';

export const MakitoRouteWatcher = () => {
  const location = useLocation();
  useEffect(() => {
    makitoHistory.history.push(location.pathname);
    makitoHistory.history.splice(0, makitoHistory.history.length - 10); // keep only last 10 entries
    makitoHistory.last = location.pathname;
  }, [location]);

  return <></>;
};
